import { render, staticRenderFns } from "./DialogRemoveRevenueStream.vue?vue&type=template&id=516f0c2f"
import script from "./DialogRemoveRevenueStream.vue?vue&type=script&lang=js"
export * from "./DialogRemoveRevenueStream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports